<template>
<div class="chapter">
<div class="inner_page">
<p class="C579"><span class="size_145"><span class="color_0B0E11"><strong><span id="page_3">Dedication</span></strong></span></span></p>
<p class="C583">For my family—I love you guys—always and forever.</p>
<p class="C572"><img alt="" src="img/4_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedicati.vue?491a2f88